import { TextCapitalized } from "../text/TextCapitalized";
import { Spacer } from "../Spacer";
import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export type ImportError = {
  cell: string;
  content: string;
  errorType: string;
};

export type ImportErrorCellProps = {
  error: ImportError;
  errorTypeToLabel: (errorType: string) => string;
};

export const ImportErrorCell = (props: ImportErrorCellProps) => {
  const { t } = useTranslation();

  const place = props.error.cell
    ? `${t("trips.importPlanning.cell")} ${props.error.cell.slice(1)}, ${props.error.cell[0]}`
    : t("trips.importPlanning.column");

  const truncatedContent =
    props.error.content && props.error.content.length > 28
      ? `${props.error.content.substring(0, 28)}...`
      : props.error.content;

  return (
    <StyledContainerCell>
      <Spacer x={0.5} />
      <StyledColumn>
        <Spacer y={0.5} />
        <StyledContent>
          <TextCapitalized>{place}</TextCapitalized>
          <StyledTypeErrors>
            {truncatedContent}
            <Spacer y={0.25} />
            <StyledTypeErrorsBottom>
              <TextCapitalized>
                {props.errorTypeToLabel(props.error.errorType)}
              </TextCapitalized>
            </StyledTypeErrorsBottom>
          </StyledTypeErrors>
        </StyledContent>
        <Spacer y={0.5} />
      </StyledColumn>
      <Spacer x={0.5} />
    </StyledContainerCell>
  );
};

const StyledColumn = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledTypeErrors = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const StyledTypeErrorsBottom = styled.div`
  ${typographies["Body/S"]};
  color: ${colors["colors/system/error/error_normal"]};
`;

const StyledContainerCell = styled.div`
  display: flex;
  border-radius: 0.5rem;
  border: 0.0625rem solid ${colors["colors/borders/cards/cards"]};
`;
